import React, { useContext, useCallback } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { I18nContext } from '@bingads-webui-react/i18n-context';
import { useDefaultStyles } from '@bingads-webui-react/with-default-styles';
import { Collapse, TextTitle, useCollapseState } from '@bingads-webui-campaign/wizard-jumbo-card';
import { SearchThemeSelector } from '@bingads-webui-campaign-react/search-theme-selector';

import SearchThemesIcon from '../media/search-themes.svg';

import { SectionShimmer } from './shimmer-element';
import { getSearchThemeDetails } from '../utils/common';
import { useTargetInstrument } from '../use-target-instrument';

const getSearchThemeSelectorStyle = () => ({
  searchThemes: {
    '& .search-theme-selector-alert .alert-warning': {
      '& .alert-image': {
        marginRight: '0.5rem',
      },
      '& .close': {
        marginLeft: '0.5rem',
        fontSize: 'inherit',
      },
    },
  },
});

export const CollapsibleSearchThemes = ({
  data,
  onDataChange,
  isLoading,
}) => {
  const i18n = useContext(I18nContext);
  const classes = useDefaultStyles(getSearchThemeSelectorStyle);
  const { searchThemesLogger } = useTargetInstrument();

  const { searchThemes } = data || {};

  const [
    allSections,
    expandedSections,
    setExpandedSections,
  ] = useCollapseState(['search-themes'], ['search-themes']);

  const searchThemesDetails = getSearchThemeDetails(i18n, searchThemes);

  const onSearchThemesChange = useCallback((newSearchThemes) => {
    searchThemesLogger.trace(`Change search themes: ${JSON.stringify(newSearchThemes)}`);
    onDataChange({
      data: prevData => ({
        ...prevData,
        searchThemes: newSearchThemes,
      }),
    });
  }, [onDataChange, searchThemesLogger]);

  return (
    <Collapse allPanelItems={allSections} checkItems activeKeys={expandedSections} setActiveKeys={setExpandedSections}>
      <Collapse.Panel
        key="search-themes"
        title={<TextTitle
          titleKey={_TL_('Search themes')}
          icon={SearchThemesIcon}
          details={searchThemesDetails}
          topicKey="pop_BA_PMAX_SearchThemes"
        />}
      >
        {
          isLoading &&
          <SectionShimmer />
        }
        {
          !isLoading &&
          <div className={classNames('search-themes-container', classes.searchThemes)}>
            <SearchThemeSelector
              searchThemes={searchThemes}
              onUpdateSearchThemes={onSearchThemesChange}
            />
          </div>
        }
      </Collapse.Panel>
    </Collapse>
  );
};

CollapsibleSearchThemes.propTypes = {
  data: PropTypes.shape({}).isRequired,
  onDataChange: PropTypes.func.isRequired,
  isLoading: PropTypes.bool,
};

CollapsibleSearchThemes.defaultProps = {
  isLoading: false,
};
